/*
  Mecca Books "The Ilm Fund" band — count-up animation + rotating
  purchase-notification cycling through either merchant-typed blocks
  (static mode) or real recent orders (dynamic mode).
*/
(function () {
  // Formats using the shop's real money_format (window.MB_ILM_MONEY_FORMAT,
  // set by the section) instead of a hardcoded $ — this store isn't
  // necessarily USD.
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
    thousands = thousands === undefined ? ',' : thousands;
    decimal = decimal === undefined ? '.' : decimal;

    var negative = number < 0 ? '-' : '';
    var n = Math.abs(number).toFixed(precision);
    var parts = n.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return negative + dollars + cents;
  }

  function formatMoney(cents) {
    var format = window.MB_ILM_MONEY_FORMAT || '${{amount}}';
    var value = cents / 100;
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;

    var formatted;
    switch (match[1]) {
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0);
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      default:
        formatted = formatWithDelimiters(value, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, formatted);
  }

  function countUp(el) {
    // The amount lives in data-ilm-amount -- data-mb-ilm-count is just a
    // bare marker attribute (no value, used only as a querySelectorAll
    // hook), so reading it here always returned "" -> NaN -> 0, which made
    // every counter (static or dynamic total) animate down to $0.00
    // regardless of the real configured/metafield amount.
    var target = parseFloat(el.getAttribute('data-ilm-amount')) || 0;
    var dur = parseInt(el.getAttribute('data-ilm-duration'), 10) || 1400;
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatMoney(Math.round(target * eased * 100));
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = formatMoney(Math.round(target * 100));
    }

    requestAnimationFrame(step);
  }

  // At narrower widths this theme leaves body/html scrollable (window fires
  // 'scroll'); at wider desktop widths (>=990px) it switches body/html to
  // overflow:hidden and makes .page-wrapper the real scrolling element
  // instead, so window never fires 'scroll' there — listening on both
  // covers either case (same fix as mecca-header.js/mecca-pdp-main.js).
  function initCounters(root) {
    var counters = root.querySelectorAll('[data-mb-ilm-count]');
    if (!counters.length) return;

    function maybeCount() {
      counters.forEach(function (c) {
        if (c._mbIlmDone) return;
        var r = c.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.88 && r.bottom > 0) {
          c._mbIlmDone = true;
          countUp(c);
        }
      });
    }

    maybeCount();
    var pageScroller = document.querySelector('.page-wrapper');
    window.addEventListener('scroll', maybeCount, { passive: true });
    if (pageScroller) pageScroller.addEventListener('scroll', maybeCount, { passive: true });
    window.addEventListener('resize', maybeCount, { passive: true });
  }

  function initNoteRotation(root) {
    var noteEl = root.querySelector('[data-mb-ilm-note]');
    var script = root.querySelector('[data-mb-ilm-notes]');
    if (!noteEl || !script) return;

    var notes = [];
    try {
      notes = JSON.parse(script.textContent) || [];
    } catch (e) {
      notes = [];
    }
    if (!notes.length) return;

    var intervalMs = parseInt(root.getAttribute('data-mb-ilm-interval'), 10) || 4000;
    var i = -1;

    function show() {
      i = (i + 1) % notes.length;
      var n = notes[i];
      var coverEl = noteEl.querySelector('[data-mb-ilm-note-cover]');
      var locationEl = noteEl.querySelector('[data-mb-ilm-note-location]');
      var bookEl = noteEl.querySelector('[data-mb-ilm-note-book]');

      if (coverEl) {
        coverEl.innerHTML = n.image ? '<img src="' + n.image + '" alt="" loading="lazy">' : '';
      }
      if (locationEl) locationEl.textContent = n.location || '';
      if (bookEl) bookEl.textContent = n.book || '';
    }

    show();

    if (notes.length > 1) {
      setInterval(function () {
        noteEl.classList.add('mb-ilm__note--swap');
        setTimeout(function () {
          show();
          noteEl.classList.remove('mb-ilm__note--swap');
        }, 500);
      }, intervalMs);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mb-ilm]').forEach(function (root) {
      initCounters(root);
      initNoteRotation(root);
    });
  });
})();